import KeyFactsBanner from "../KeyFactsBanner";
// import Style from './KeyFactsStatement.module.scss'
import KeyServices from "../KeyServices";
import heroImage from "../../assets/key-facts-statement/key-facts-hero.jpg";

const KeyFactsStatement = () => {
  return (
    <div>
      <KeyFactsBanner title="Key Facts Statement" image={heroImage} />
      <KeyServices />
    </div>
  );
};

export default KeyFactsStatement;
